var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00019 3.33203C11.2289 3.33203 14.0108 5.24467 15.2748 7.99872C14.0108 10.7527 11.2289 12.6654 8.00021 12.6654C4.77154 12.6654 1.98959 10.7527 0.725586 7.99867C1.9896 5.24465 4.77154 3.33203 8.00019 3.33203ZM8.00021 11.6654C5.34248 11.6654 3.02884 10.1842 1.84304 7.99868C3.02885 5.8132 5.34247 4.33203 8.00019 4.33203C10.6579 4.33203 12.9715 5.81322 14.1574 7.99872C12.9715 10.1842 10.6579 11.6654 8.00021 11.6654Z",
    fill: "#0B3A81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6663 7.9987C10.6663 9.47146 9.47243 10.6654 7.99967 10.6654C6.52692 10.6654 5.33301 9.47146 5.33301 7.9987C5.33301 6.52594 6.52692 5.33203 7.99967 5.33203C9.47243 5.33203 10.6663 6.52594 10.6663 7.9987ZM9.66634 7.9987C9.66634 8.91917 8.92015 9.66536 7.99967 9.66536C7.0792 9.66536 6.33301 8.91917 6.33301 7.9987C6.33301 7.07822 7.0792 6.33203 7.99967 6.33203C8.92015 6.33203 9.66634 7.07822 9.66634 7.9987Z",
    fill: "#0B3A81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.42de04e8b82a148040ddb1cc7993d36e.svg";
export { ForwardRef as ReactComponent };